import { object, string } from 'yup';

export const questionSchema = object({
  question: string().required(),
});

export const feedbackFormsSchema = object({
 
});

export const submitCustomerFeedbackSchema = object({
  submitCustomerFeedback: object({
    customerFeedback: object({
      id: string().nonNullable().required(),
    }).required(),
  }).required(),
});
